export default {
  header: 'Ups, coś nieoczekiwanego się wydarzyło',
  text: 'Uruchom ponownie stronę lub kliknij przycisk „Powrót do menu" poniżej.',
  button: 'Powrót do początku',
};
